import * as API from '../../../api'
import _filter from 'lodash/filter'

function buildAnsId (answer) {
  return {
    key: answer.question_sub ? 'question_sub' : 'question',
    value: answer.question_sub ? answer.question_sub : answer.question
  }
}

const addRemovePoll = (context, answer) => {
  console.log('addRemovePoll', answer);
  if (answer.checked) {
    context.dispatch('polls/getPoll', answer.surveyId, { root: true })
  } else {
    context.dispatch('polls/removePoll', answer.surveyId, { root: true })
  }
};

const addRemoveAnswer = (context, answer) => {
  // const ansId = answer.question_sub ? answer.question_sub : answer.id;
  let ansId = buildAnsId(answer)
  const ans = context.getters.getAnswer(ansId)
  if (ans) {
    ansId = buildAnsId(ans)
    const idx = context.getters.getAnswerIndex(ansId)
    if (idx < 0) {
      console.error('cant find answer index', ans)
    }
    if ((answer.options && !answer.options.length) || answer.checked === false) {
      // console.log('commit remove answer', answer.id);
      context.commit('removeAnswer', idx)
    } else {
      // console.log('commit updAnswer', idx);
      context.commit('updAnswer', { answer, idx })
    }
  } else {
    context.commit('setAnswer', answer)
  }
};

const sendAnswers = async (context) => {
  let answers;
  const userId = context.rootState.session.userId;
  answers = _filter(context.state.answers, (o) => {
    return o.pollId !== 'profile'
  }).map((answer) => {
    answer.user = userId;
    if (answer.options) {
      answer.options = answer.options.map((item) => {
        return item.id
      })
    }
    return answer
  });

  const result = await API.sendAnswers(answers);
  if (result.data && result.data.length) {
    const linkToExel = await API.emitCreateExel(userId);
    if (linkToExel.data) {
      context.commit('setExelLink', linkToExel.data);
      context.dispatch('session/removeSessionData', null, { root: true })
    }
  }
  return result
}

export default {
  addRemovePoll,
  addRemoveAnswer,
  sendAnswers
}
